import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FaqDialog } from "./faq-dialog";

export function NewFaqDialog({
  variant = "default",
}: {
  variant?: "default" | "empty";
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {variant === "empty" ? (
        <Button onClick={() => setOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Add your first FAQ entry
        </Button>
      ) : (
        <Button size="sm" onClick={() => setOpen(true)}>
          <Plus className="mr-1.5 h-3.5 w-3.5" />
          New FAQ
        </Button>
      )}
      {open ? (
        <FaqDialog open={open} onOpenChange={setOpen} mode={{ kind: "create" }} />
      ) : null}
    </>
  );
}
